import clsx from "clsx";
import type { FC } from "react";

import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { LoadingDotsIcon } from "mds/icons";

interface StartButtonProps {
  disabled: boolean;
  isLoading: boolean;
  onClick: () => void;
}

// TODO: will rename to ConfirmGroupButton in a follow-up PR
export const StartButton: FC<StartButtonProps> = ({ disabled, isLoading, onClick }) => {
  return (
    <SquareButton
      className={clsx(isLoading && "cursor-not-allowed")}
      disabled={disabled}
      kind="success"
      size="xs"
      title={
        disabled
          ? t("student_self_select_card.tooltip.group_full")
          : t("student_self_select_card.tooltip.start_activity")
      }
      onClick={isLoading ? undefined : onClick}
    >
      {isLoading ? <LoadingDotsIcon /> : t("common.confirm_group")}
    </SquareButton>
  );
};
